import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { KeyQuestionUi } from '../../../../interfaces/responsedata.ts/generic-streams';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export enum OpenQuestionDialogState {
    NEXT = "NEXT",
    BACK = "BACK",
}

@Component({
    selector: 'app-step-not-completed',
    standalone: false,
    templateUrl: './step-not-completed.component.html',
    styleUrl: './step-not-completed.component.scss'
})

export class StepNotCompletedComponent implements OnInit {
    data: { state: OpenQuestionDialogState, questions: KeyQuestionUi[] } = inject(MAT_DIALOG_DATA);
    dia = inject(MatDialogRef<StepNotCompletedComponent>)
    private destroyRef = inject(DestroyRef);

    OpenQuestionDialogState = OpenQuestionDialogState;

    ngOnInit(): void {
        this.dia.keydownEvents()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
                next: (event) => {
                    if (event.key === 'Enter') {
                        event.preventDefault();
                        this.close();
                    } else if (event.key === 'Escape') {
                        event.preventDefault();
                        this.ignore();
                    }
                },
            });
    }

    ignore() {
        this.dia.close();
    }
    close(questionIndex: number | true = true) {
        this.dia.close(questionIndex);
    }
}

